// Fachada do domínio Comissões — métodos da instância (ver core.ts).
import { commissionService } from './core';
import {
  summarizeCommissions,
  groupByParcelaAndType,
  simulateCommissions,
} from '@modules/commission';

// ─── Operações com dados (via adapter) ──────────────────────────
export const listCommissions    = commissionService.listCommissions;
export const getCommissionByCard = commissionService.getCommissionByCard;
export const getCommissionRates  = commissionService.getCommissionRates;
export const setCommissionRates  = commissionService.setCommissionRates;
export const listUsersByRole     = commissionService.listUsersByRole;

// ─── Funções puras (reexportadas do módulo) ─────────────────────
export { summarizeCommissions, groupByParcelaAndType, simulateCommissions };

// ─── Tipos ──────────────────────────────────────────────────────
export type {
  ParcelaBucket,
  ParcelaGroups,
  SimulationScenario,
  SimulationBreakdownItem,
  SimulationResult,
} from '@modules/commission';
export type { ListCommissionsParams } from '@modules/commission';
